/**
 * @module components\ghBusinessTree
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Model, Watch, Emit } from "vue-property-decorator";
import { MethodService } from "./../../utils/serviceModel";
import { TreeNode } from "element-ui/types/tree";
import { ElTree } from "element-ui/types/tree";
import { State } from "vuex-class";

@Component({
  name: "gh-business-tree"
})
export default class GhBusinessTree extends Vue {
  @Model("current-change")
  private selected!: any;

  @Prop()
  private module!: string;

  @Prop()
  private cls!: string;

  @Prop({ default: "get_tree" })
  private method!: string;

  @Prop({ default: null })
  private parentId!: string;

  @Prop()
  private columns!: string[];

  @Prop({ default: true })
  private showToolbar!: boolean;

  @Prop({ default: false })
  private defaultExpandAll!: boolean;

  @Prop({ default: false })
  private accordion!: boolean;

  @Prop({ default: true })
  private draggable!: boolean;

  @Prop({ default: false })
  private attachedAll!: boolean;
  @State(state => state.loginer)
  protected loginer: ILoginer;

  @Prop({
    default: () => {
      return { ["label"]: "Name", children: "children" };
    }
  })
  private props!: any;

  @Prop({ default: false })
  private expandOnClickNode!: boolean;

  private data: any[] = [];

  private currentKey: string = "-1";

  private expandedKeys: any[] = ["-1"];

  private isBusy = false;

  private get ExpandedKeys() {
    if (this.accordion) {
      return undefined;
    }
    return this.expandedKeys;
  }

  private get Tree() {
    return this.$refs.tree as ElTree<any,any>;
  }

  private currentChange(data, node: TreeNode<any, any>) {
    if (node && node.key) {
      this.currentKey = node.key;
      this.$emit("current-change", node);
    }
  }

  private nodeExpand(data, node: TreeNode<any, any>) {
    let index = this.expandedKeys.indexOf(node.key);
    if (index < 0) {
      this.expandedKeys.push(node.key);
      this.$emit("update:defaultExpandedKeys", this.expandedKeys);
    }
  }

  private nodeCollapse(data, node: TreeNode<any, any>) {
    this.collapse(node);
    console.log(this.expandedKeys);
    this.$emit("update:defaultExpandedKeys", this.expandedKeys);
  }

  private collapse(node: TreeNode<any, any>) {
    let index = this.expandedKeys.indexOf(node.key);
    if (index > -1) {
      this.expandedKeys.splice(index, 1);
      if (node.childNodes) {
        for (let cNode of node.childNodes) {
          this.collapse(cNode);
        }
      }
    }
  }

  private async nodeDrop(
    source: TreeNode<string, any>,
    target: TreeNode<string, any>,
    pos
  ) {
    this.isBusy = true;
    await this.svNodeDrop.invokeAsyn({
      source_id: source.key,
      target_id: target.key,
      ["pos"]: pos
    });
    this.query();
  }

  public async query() {
    this.isBusy = true;
    this.$emit("start-query");
    let res = await this.svGetTree.invokeAsyn({
      parent_id: this.parentId,
      columns: this.columns,
      attached_all: this.attachedAll,
      enterprise: this.loginer.Site ? this.loginer.Site.Id : null
    });
    if (res.data.isSuccess) {
      if (res.data.data) {
        if (res.data.data instanceof Array) {
          this.data = res.data.data;
        } else {
          this.data = [res.data.data];
        }
      }
    } else {
      this.data = [];
    }
    this.isBusy = false;
    this.$emit("completed", this.data);

    if (this.Tree) {
      this.$nextTick(() => {
        this.Tree.setCurrentKey(this.currentKey);
      });
    }
  }

  @Watch("module")
  private observeModule() {
    this.updateMethod();
  }

  @Watch("cls")
  private updateMethod() {
    if (this.module && this.cls && this.method) {
      this.svGetTree = this.getService(this.method);
      this.svNodeDrop = this.getService("node_drop");
      this.query();
    }
  }

  created() {}
  mounted() {
    this.updateMethod();
  }
  private getService(method: string) {
    return this.$createService(this.module, this.cls, method);
  }
  private svGetTree: MethodService;
  private svNodeDrop: MethodService;
}
